import React, { useEffect, useState } from "react";
import "atropos/atropos.css";
import GetInTouch from "../components/GetInTouch/GetInTouch";
import AtroposCarousel from "../components/Carousel/AtroposCarousel";
import project from "../project.json";

const HomeContainer = ({ isActive }) => {
  const [projectData, setProjectData] = useState(project);
  const [display, setDisplay] = useState("none");

  useEffect(() => {
    isActive ? setDisplay("block") : setDisplay("none");
  }, [isActive]);

  return (
    <div id="homeWrapper" style={{ display: display }}>
      {projectData.map((data) => {
        if (data.isSelected) {
          return (
            <AtroposCarousel
              title={data.title}
              owner={data.owner}
              style={{ transform: "matrix(1, 0, 0, 1, -500, 0)" }}
              scope={data.scope}
              role={data.role}
              usecase={data.case}
              live={data.live}
              watchVideo={data.video}
              promotionVid={data.promotionVid}
              poster={data.poster}
            />
          );
        }
      })}
      <div className="spacer" data-height="200" />
      <GetInTouch />
    </div>
  );
};

export default HomeContainer;
